<template>
<div class="containers">
    <CRow v-if="goArea == '1'" class="p-4" style="background-color:rgba(249, 250, 252, 1)">
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Data</div>
                    <div class="card-subtitle">Data total pegawai bulan {{this.date.month}}</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalData}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Generate</div>
                    <div class="card-subtitle">Data pegawai yang berhasil generate bulan {{this.date.month}}</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalGenerate}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Belum Generate</div>
                    <div class="card-subtitle">Data pegawai yang belum generate bulan {{this.date.month}}</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalBelumGenerate}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
    </CRow>
    <div v-if="goArea == '1'" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="7">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="3">
                    <month-picker-input placeholder="Bulan" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4">
                    <CButton color="primary" @click="goArea = '3'" class="mr-3" variant='outline'>Import Slip Gaji</CButton>
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton style="float:right" @click="showModal = true" color="success" class="w-100" variant='outline'>Generate</CButton>
                </CCol>
            </CRow>
        </div>  
        <CModal
            size="md"
            :centered="true"
            color="white"
            :show.sync="showModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="showModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="12">
                            Apakah anda yakin ingin menyimpan data gaji bulan ini?
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="12">
                        <CButton @click="showModal = false" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                        <CButton :disabled="loadingGenerate == true" @click="goGenerate()" class="btn btn-edit-submit">
                            <span v-if="loadingGenerate == false">Ya, Simpan</span>
                            <CSpinner v-else color="default" size="sm"/>
                        </CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <Tables @sort="sorting" @edit="editData" @view="viewData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Slip Gaji</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            : <span class="font-weight-bold">{{viewNama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            : {{viewNik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Periode
                        </CCol>
                        <CCol sm="9">
                            : {{viewBulanConvert}} - {{viewTahun}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Hari Kerja Pegawai
                        </CCol>
                        <CCol sm="9">
                            : {{viewHkp}}
                        </CCol>
                    </CRow>
                    <hr class="mt-2" v-if="viewDetailPenghasilanTetap.length != 0 || viewDetailPenghasilanTidakTetap.length != 0" />
                    <CRow>
                        <CCol sm="6">
                            <CRow v-for="(data, id1) in viewDetailPenghasilanTetap" :key="id1" class="mt-1">
                                <CCol sm="6">
                                    {{data.keterangan}} <span v-if="data.interval != 'H'">({{separatorInterval(data.interval)}})</span><span v-if="data.interval == 'H'"> - Rp. {{separatorRupiah(data.nominal)}} x {{viewHkp}} Hari</span><span v-if="data.satuan == 'P'"> - {{data.nominal}} %</span>
                                </CCol>
                                <CCol sm="6 text-right">
                                    Rp. <span v-if="data.interval == 'H' || data.satuan == 'P'">{{separatorRupiah(data.nominalHitung)}}</span><span v-else>{{separatorRupiah(data.nominal)}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="7">
                                    <span class="font-weight-bold">Total Penghasilan Tetap</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    <span class="font-weight-bold">Rp. {{separatorRupiah(viewTotalPenghasilanTetap)}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <CRow v-for="(data2, id3) in viewDetailPenghasilanTidakTetap" :key="id3" class="mt-1">
                                <CCol sm="7">
                                    {{data2.keterangan}} <span v-if="data2.interval != 'H'">({{separatorInterval(data2.interval)}})</span><span v-if="data2.interval == 'H'"> - Rp. {{separatorRupiah(data2.nominal)}} x {{viewHkp}} Hari</span><span v-if="data2.satuan == 'P'"> - {{data2.nominal}} %</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    Rp. <span v-if="data2.interval == 'H' || data2.satuan == 'P'">{{separatorRupiah(data2.nominalHitung)}}</span><span v-else>{{separatorRupiah(data2.nominal)}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="7">
                                    <span class="font-weight-bold">Total Penghasilan Tidak Tetap</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    <span class="font-weight-bold">Rp. {{separatorRupiah(viewTotalPenghasilanTidakTetap)}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <hr class="mt-2" v-if="viewDetailDitanggungPegawai.length != 0 || viewDetailDitanggungPerusahaan.length != 0" />
                    <CRow>
                        <CCol sm="6">
                            <CRow v-for="(data3, id3) in viewDetailDitanggungPegawai" :key="id3" class="mt-1">
                                <CCol sm="7">
                                    {{data3.keterangan}} <span v-if="data3.interval != 'H'">({{separatorInterval(data3.interval)}})</span><span v-if="data3.interval == 'H'"> - Rp. {{separatorRupiah(data3.nominal)}} x {{viewHkp}} Hari</span><span v-if="data3.satuan == 'P'"> - {{data3.nominal}} %</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    Rp. <span v-if="data3.interval == 'H' || data3.satuan == 'P'">{{separatorRupiah(data3.nominalHitung)}}</span><span v-else>{{separatorRupiah(data3.nominal)}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="7">
                                    <span class="font-weight-bold">Total Potongan Ditanggung Pegawai</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    <span class="font-weight-bold">Rp. {{separatorRupiah(viewTotalDitanggungPegawai)}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <CRow v-for="(data4, id4) in viewDetailDitanggungPerusahaan" :key="id4" class="mt-1">
                                <CCol sm="7">
                                    {{data4.keterangan}} <span v-if="data4.interval != 'H'">({{separatorInterval(data4.interval)}})</span><span v-if="data4.interval == 'H'"> - Rp. {{separatorRupiah(data4.nominal)}} x {{viewHkp}} Hari</span><span v-if="data4.satuan == 'P'"> - {{data4.nominal}} %</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    Rp. <span v-if="data4.interval == 'H' || data4.satuan == 'P'">{{separatorRupiah(data4.nominalHitung)}}</span><span v-else>{{separatorRupiah(data4.nominal)}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="7">
                                    <span class="font-weight-bold">Total Potongan Ditanggung Perusahaan</span>
                                </CCol>
                                <CCol sm="5 text-right">
                                    <span class="font-weight-bold">Rp. {{separatorRupiah(viewTotalDitanggungPerusahaan)}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <hr class="mt-2" />
                    <CRow>
                        <CCol sm="12">
                            <CRow class="mt-1">
                                <CCol sm="6">
                                    <span class="font-weight-bold">Total Gaji</span>
                                </CCol>
                                <CCol sm="6 text-right">
                                    <span class="font-weight-bold">Rp. {{separatorRupiah(viewTotalGaji)}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6">
                        <CButton @click="showSlip()" style="float:left" class="btn-success">View Slip</CButton>
                    </CCol>
                    <CCol sm="6">
                        <CButton @click="detailModal = false" style="float:right" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
    <div v-if="goArea == '2'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control" 
                            v-model="editNama"
                            placeholder="Nama Pegawai" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>NIP</label>
                        <input 
                            disabled
                            class="form-control" 
                            style="background-color:whitesmoke"
                            v-model="editNik"
                            placeholder="NIP" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Bulan</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control" 
                            v-model="editBulanConvert"
                            placeholder="Bulan" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tahun</label>
                        <input 
                            disabled
                            class="form-control" 
                            style="background-color:whitesmoke"
                            v-model="editTahun"
                            placeholder="Tahun" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr v-if="editDetailPenghasilanTetap.length != 0"/>
                <CRow class="mb-2" v-if="editDetailPenghasilanTetap.length != 0">
                    <CCol sm="12">
                        <span class="font-weight-bold">Penghasilan Tetap</span>
                    </CCol>
                </CRow>
                <CRow v-if="editDetailPenghasilanTetap.length != 0">
                    <CCol v-for="(data, id1) in editDetailPenghasilanTetap" :key="id1" sm="6">
                        <label>{{data.keterangan}} / {{separatorInterval(data.interval)}} ({{separatorSatuan(data.satuan)}})</label>
                        <input 
                            v-if="data.satuan == 'N'"
                            class="form-control"
                            @input="rupiahModeUangSaku('penghasilanTetap', id1)"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            v-model="data.nominal"
                            :placeholder="data.keterangan" 
                            type="text"
                        />
                        <input 
                            v-else
                            class="form-control"
                            v-model="data.nominal"
                            :placeholder="data.keterangan"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr v-if="editDetailPenghasilanTidakTetap.length != 0"/>
                <CRow class="mb-2" v-if="editDetailPenghasilanTidakTetap.length != 0">
                    <CCol sm="12">
                        <span class="font-weight-bold">Penghasilan Tidak Tetap</span>
                    </CCol>
                </CRow>
                <CRow v-if="editDetailPenghasilanTidakTetap.length != 0">
                    <CCol v-for="(data2, id2) in editDetailPenghasilanTidakTetap" :key="id2" sm="6">
                        <label>{{data2.keterangan}} / {{separatorInterval(data2.interval)}} ({{separatorSatuan(data2.satuan)}})</label>
                        <input 
                            v-if="data2.satuan == 'N'"
                            @input="rupiahModeUangSaku('penghasilanTidakTetap', id2)"
                            class="form-control"
                            v-model="data2.nominal"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            :placeholder="data2.keterangan" 
                            type="text"
                        />
                        <input 
                            v-else
                            class="form-control"
                            v-model="data2.nominal"
                            :placeholder="data2.keterangan" 
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr v-if="editDetailDitanggungPegawai.length != 0"/>
                <CRow class="mb-2" v-if="editDetailDitanggungPegawai.length != 0">
                    <CCol sm="12">
                        <span class="font-weight-bold">Potongan Ditanggung Pegawai</span>
                    </CCol>
                </CRow>
                <CRow v-if="editDetailDitanggungPegawai.length != 0">
                    <CCol v-for="(data3, id3) in editDetailDitanggungPegawai" :key="id3" sm="6">
                        <label>{{data3.keterangan}} / {{separatorInterval(data3.interval)}} ({{separatorSatuan(data3.satuan)}})</label>
                        <input 
                            v-if="data3.satuan == 'N'"
                            @input="rupiahModeUangSaku('ditanggungPegawai', id3)"
                            class="form-control"
                            v-model="data3.nominal"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            :placeholder="data3.keterangan" 
                            type="text"
                        />
                        <input 
                            v-else
                            class="form-control"
                            v-model="data3.nominal"
                            :placeholder="data3.keterangan" 
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr v-if="editDetailDitanggungPerusahaan.length != 0"/>
                <CRow class="mb-2" v-if="editDetailDitanggungPerusahaan.length != 0">
                    <CCol sm="12">
                        <span class="font-weight-bold">Potongan Ditanggung Perusahaan</span>
                    </CCol>
                </CRow>
                <CRow v-if="editDetailDitanggungPerusahaan.length != 0">
                    <CCol v-for="(data4, id4) in editDetailDitanggungPerusahaan" :key="id4" sm="6">
                        <label>{{data4.keterangan}} / {{separatorInterval(data4.interval)}} ({{separatorSatuan(data4.satuan)}})</label>
                        <input 
                            v-if="data4.satuan == 'N'"
                            @input="rupiahModeUangSaku('ditanggungPerusahaan', id4)"
                            class="form-control"
                            v-model="data4.nominal"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            :placeholder="data4.keterangan" 
                            type="text"
                        />
                        <input 
                            v-else
                            class="form-control"
                            v-model="data4.nominal"
                            :placeholder="data4.keterangan" 
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
    <div v-if="goArea == '3'" class="area-edit">
        <CAlert
        v-if="successImport == true"
        :show.sync="currentAlertCounterImport"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMessImport}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounterImport"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMessImport}}
        </CAlert>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="goArea = '1', dataImport = [], infoImport = '', jumlahInvalid = '', jumlahValid = ''" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Unduh Template Excel Slip Gaji</label>
                        <div>
                            <CButton style="width:200px" @click="getDownloadTemplate()" color="primary" variant='outline'><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'download'}" />Export Template Gaji</CButton>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Import Slip Gaji (.xls)</label>
                        <div>
                            <CButton style="width:200px" color="primary" onclick="document.getElementById('inputFile').click()" variant='outline'>
                                <span v-if="loadingUpload == false"><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'upload'}" />Import Excel</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                            <input type="file" @change="loadFile()" style="display:none" accept=".xls, .xlsx" id="inputFile" class="hide" />
                        </div>
                    </CCol>
                </CRow>
                <CRow class="mt-4">
                    <CRow v-if="dataImport != [] && dataImport.data != undefined">
                        <CCol sm="4">
                            Nama File
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold font-italic">{{infoImport}}</span>
                        </CCol>
                        <CCol sm="4">
                            Total data
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataImport.data.length}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Total data yang sukses
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{jumlahValid}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Total data yang tidak ditemukan
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{jumlahInvalid}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Export Result Review
                        </CCol>
                        <CCol sm="8">
                            : <img class="mr-5 mt-1" @click="getDownloadReview()" style="cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                    <div v-if="dataImport != ''" class="mt-1" style="overflow-x:auto;">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(head, id) in dataImport.kolom" :key="id">{{head}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="dataImport.data.length != 0">
                                <tr v-for="(row, ids) in dataImport.data" :key="ids">
                                    <td v-for="(col, index) in row" :key="index">{{col}}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr >
                                    <td class="text-center" :colspan="dataImport.kolom.length">Maaf, Data Excel Kosong</td>
                                </tr>
                            </tbody>     
                        </table>
                    </div>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit" v-if="dataImport != [] && dataImport.data != undefined">
            <CCol sm="12">
                <CButton @click="goArea = '1', dataImport = [], infoImport = '', jumlahInvalid = '', jumlahValid = ''" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="dataImport.data.length != 0" @click="sumbitImport()" class="btn btn-edit-submit">
                    <span v-if="loadingImport == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableGaji'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { MonthPickerInput } from 'vue-month-picker'

export default {
    components: {
        ModelSelect,
        Tables,
        MonthPickerInput
    },
    mixins: [validationMixin],
    validations: {
    },
    data() {
        return {
            showModal: false,
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            success: true,
            successImport: false,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama / NIP', 'HKP', 'Total Penghasilan', 'Total Potongan', 'Total Gaji', 'Action'],
            dataTd: [['nama', 'nik'], 'hkp', 'totalPendapatan', 'totalDitanggungPegawai', 'totalGaji', 'actions'],
            styleTable: ['100px', '50px', '75px', '75px', '75px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: '1',
            loading: false,
            loadingImport: false,
            loadingUpload: false,
            currentAlertCounter: 0,
            currentAlertCounterImport: 0,

            // data model

            tipe: 'U',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            totalData: 0,
            totalGenerate: 0,
            totalBelumGenerate: 0,

            // filter
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),
            placeHolder: '',

            // data
            editNama: '',
            editNik: '',
            editTotalGaji: '',

            editTotalPenghasilanTetap: '',
            editTotalPenghasilanTidakTetap: '',
            editTotalDitanggungPegawai: '',
            editTotalDitanggungPerusahaan: '',

            editDetailPenghasilanTetap: '',
            editDetailPenghasilanTidakTetap: '',
            editDetailDitanggungPegawai: '',
            editDetailDitanggungPerusahaan: '',


            editUnix: '',
            editIdPeg: '',
            editBulan: '',
            editTahun: '',
            editProrate: '',
            editBulanConvert: '',


            // view
            detailModal: false,
            viewNama: '',
            viewNik: '',
            viewTotalGaji: '',

            viewTotalPenghasilanTetap: '',
            viewTotalPenghasilanTidakTetap: '',
            viewTotalDitanggungPegawai: '',
            viewTotalDitanggungPerusahaan: '',

            viewDetailPenghasilanTetap: '',
            viewDetailPenghasilanTidakTetap: '',
            viewDetailDitanggungPegawai: '',
            viewDetailDitanggungPerusahaan: '',

            viewUnix: '',
            viewIdPeg: '',
            viewBulan: '',
            viewTahun: '',
            viewHkp: '',
            viewBulanConvert: '',

            // import
            infoImport: '',
            dataImport: '',
            errImport: '',
            jumlahInvalid: '',
            jumlahValid: '',
            tableReview: [],

            // error
            errorMessage: '',
            loadingGenerate: false
        }
    },
    watch: {
        page() {
            this.getData()
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.page = 1
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.getDataPegawai()
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        date() {
            this.page = 1
        },
        detailModal() {
            if(this.detailModal == false) {
                this.viewNama = ''
                this.viewNik = ''
                this.viewTotalGaji = ''
                this.viewTotalPenghasilan = ''
                this.viewTotalPengurangan = ''
                this.viewTotalPenguranganTidakDitanggung = ''
                this.viewDetailPenghasilan = ''
                this.viewDetailPengurangan = ''
                this.viewDetailPenguranganTidakDitanggung = ''
                this.viewUnix = ''
                this.viewBulan = ''
                this.viewTahun = ''
                this.viewIdPeg = ''
            }
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        showDate(date) {
            this.date = date
        },
        setDate() {
            this.date = this.tanggal
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year

            
            let bulan = ''
            if(month == 1) {
                bulan = 'January'
            } else if(month == 2) {
                bulan = 'February'
            } else if(month == 3) {
                bulan = 'March'
            } else if(month == 4) {
                bulan = 'April'
            } else if(month == 5) {
                bulan = 'May'
            } else if(month == 6) {
                bulan = 'June'
            } else if(month == 7) {
                bulan = 'July'
            } else if(month == 8) {
                bulan = 'August'
            } else if(month == 9) {
                bulan = 'September'
            } else if(month == 10) {
                bulan = 'October'
            } else if(month == 11) {
                bulan = 'November'
            } else if(month == 12) {
                bulan = 'December'
            }

            this.date.month = bulan

            this.placeHolder = bulan + ', ' + year
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        goGenerate() {
            this.loadingGenerate = true
            DataApi.get("salary/generate")
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.showModal = false
                this.loadingGenerate = false
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        showSlip() {
            let payload = {
                unix: this.viewUnix
            }
            DataApi.post("/export/salary/transaksi/lihat/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
            })
        },
        getDownloadTemplate() {
            let payload = {}
            DataApi.post("/export/salary/transaksi/import/template", payload, {responseType: 'blob'})
            .then(res => {
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Template Slip Gaji')
                document.body.appendChild(link)
                link.click()
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                let nama = ''
                let idPegawai = ''
                if(this.idPegawai == '') {
                    nama = this.queryPegawai
                    idPegawai = ''
                } else {
                    nama = ''
                    idPegawai = this.idPegawai
                }
                let payload = {
                    idPegawai: idPegawai,
                    limit: this.size,
                    nama: nama,
                    bulan: this.date.monthIndex,
                    tahun: this.date.year,
                    pageIn: this.page
                }
                DataApi.post("/export/salary/transaksi", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Slip Gaji')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        getDownloadReview() {
            let payload = {
                jumlahInvalid: this.jumlahInvalid,
                jumlahValid: this.jumlahValid,
                kolom: this.dataImport.kolom,
                data: this.dataImport.data,
            }
            DataApi.post("/export/salary/transaksi/priview/import", payload, {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Import Review Slip Gaji')
                    document.body.appendChild(link)
                    link.click()
                })
        },
        getData() {
            this.$store.state.loadingScreen = true
            let nama = ''
            let idPegawai = ''
            if(this.idPegawai == '') {
                nama = this.queryPegawai
                idPegawai = ''
            } else {
                nama = ''
                idPegawai = this.idPegawai
            }
            let payload = {
                idPegawai: idPegawai,
                limit: this.size,
                nama: nama,
                bulan: this.date.monthIndex,
                tahun: this.date.year,
                pageIn: this.page
            }
            DataApi.post("salary/transaksi/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    
                    this.datas = response.data.data
                    this.totalData = response.data.totalPegawai
                    this.totalGenerate = response.data.totalRow
                    this.totalBelumGenerate = this.totalData - this.totalGenerate
                    if (this.totalBelumGenerate < 0) {
                        this.totalBelumGenerate = 0
                    }
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.totalPage = 1
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalData = 0
                    this.totalGenerate = 0
                    this.totalBelumGenerate = 0
                    this.page = 1
                    this.errorMessage = response.message
                }
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.page = 1
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == '1') {
                this.goArea = '2'
            } else {
                this.goArea = '1'
                this.tipe = 'U'
                this.$v.$reset()
            }
        },
        goSave() {
            let data = this.editDetailPenghasilanTetap
            let data2 = this.editDetailPenghasilanTidakTetap
            let data3 = this.editDetailDitanggungPegawai
            let data4 = this.editDetailDitanggungPerusahaan

            var i,j,k,l = 0
            for(i=0;i<data.length;i++) {
                let sat = data[i].satuan
                let result = ''
                if(sat == 'N') {
                    let nom = data[i].nominal
                    let clear = ''
                    if(nom != '') {
                        if(nom[0] == 'R') {
                            clear = nom.replace('Rp. ', '')
                            var ii = 0
                            for(ii=0;ii<clear.length;ii++) {
                                if(clear[ii] == '.') {
                                    // nothing
                                } else {
                                    result += clear[ii]
                                }
                            }
                        }
                    } else {
                        result = '0'
                    }
                    data[i].nominal = result
                }
            }

            for(j=0;j<data2.length;j++) {
                let sat = data2[j].satuan
                let result = ''
                if(sat == 'N') {
                    let nom = data2[j].nominal
                    let clear = ''
                    if(nom != '') {
                        if(nom[0] == 'R') {
                            clear = nom.replace('Rp. ', '')
                            var jj = 0
                            for(jj=0;jj<clear.length;jj++) {
                                if(clear[jj] == '.') {
                                    // nothing
                                } else {
                                    result += clear[jj]
                                }
                            }
                        }
                    } else {
                        result = '0'
                    }
                    data2[j].nominal = result
                }
            }

            for(k=0;k<data3.length;k++) {
                let sat = data3[k].satuan
                let result = ''
                if(sat == 'N') {
                    let nom = data3[k].nominal
                    let clear = ''
                    if(nom != '') {
                        if(nom[0] == 'R') {
                            clear = nom.replace('Rp. ', '')
                            var kk = 0
                            for(kk=0;kk<clear.length;kk++) {
                                if(clear[kk] == '.') {
                                    // nothing
                                } else {
                                    result += clear[kk]
                                }
                            }
                        }
                    } else {
                        result = '0'
                    }
                    data3[k].nominal = result
                }
            }

            for(l=0;l<data4.length;l++) {
                let sat = data4[l].satuan
                let result = ''
                if(sat == 'N') {
                    let nom = data4[l].nominal
                    let clear = ''
                    if(nom != '') {
                        if(nom[0] == 'R') {
                            clear = nom.replace('Rp. ', '')
                            var ll = 0
                            for(ll=0;ll<clear.length;ll++) {
                                if(clear[ll] == '.') {
                                    // nothing
                                } else {
                                    result += clear[ll]
                                }
                            }
                        }
                    } else {
                        result = '0'
                    }
                    data4[l].nominal = result
                }
            }

            let payload = {
                bulan: this.editBulan,
                daftarPenghasilanTetap: data,
                daftarPenghasilanTidakTetap: data2,
                daftarDitanggungPegawai: data3,
                daftarDitanggungPerusahaan: data4,
                idPegawai: this.editIdPeg,
                prorate: this.editProrate,
                tahun: this.editTahun,
                unix: this.editUnix
            }
            DataApi.post("salary/transaksi/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.editNama = generate.nama
            this.editNik = generate.nik

            this.editDetailPenghasilanTetap = generate.daftarPenghasilanTetap,
            this.editDetailPenghasilanTidakTetap = generate.daftarPenghasilanTidakTetap,
            this.editDetailDitanggungPegawai = generate.daftarDitanggungPegawai,
            this.editDetailDitanggungPerusahaan = generate.daftarDitanggungPerusahaan,

            this.editUnix = generate.unix
            this.editBulan = generate.bulan
            this.editTahun = generate.tahun
            this.editIdPeg = generate.idPegawai
            this.editProrate = generate.prorate

            let bulan = this.editBulan
            let month = ''
            if(bulan == '1' || bulan == '01') {
                month = 'Januari'
            } else if(bulan == '2' || bulan == '02') {
                month = 'Februari'
            } else if(bulan == '3' || bulan == '03') {
                month = 'Maret'
            } else if(bulan == '4' || bulan == '04') {
                month = 'April'
            } else if(bulan == '5' || bulan == '05') {
                month = 'Mei'
            } else if(bulan == '6' || bulan == '06') {
                month = 'Juni'
            } else if(bulan == '7' || bulan == '07') {
                month = 'Juli'
            } else if(bulan == '8' || bulan == '08') {
                month = 'Agustus'
            } else if(bulan == '9' || bulan == '09') {
                month = 'September'
            } else if(bulan == '10') {
                month = 'Oktober'
            } else if(bulan == '11') {
                month = 'November'
            } else if(bulan == '12') {
                month = 'Desember'
            }

            this.editBulanConvert = month

            
            this.tipe = 'U'

            let data = this.editDetailPenghasilanTetap
            let data2 = this.editDetailPenghasilanTidakTetap
            let data3 = this.editDetailDitanggungPegawai
            let data4 = this.editDetailDitanggungPerusahaan


            var i,j,k,l = 0
            for(i=0;i<data.length;i++) {
                if(data[i].satuan == 'N') {
                    this.rupiahModeUangSaku('penghasilanTetap',i)
                }
            }
            for(j=0;j<data2.length;j++) {
                if(data2[j].satuan == 'N') {
                    this.rupiahModeUangSaku('penghasilanTidakTetap',j)
                }
            }
            for(k=0;k<data3.length;k++) {
                if(data3[k].satuan == 'N') {
                    this.rupiahModeUangSaku('ditanggungPegawai',k)
                }
            }
            for(l=0;l<data4.length;l++) {
                if(data4[l].satuan == 'N') {
                    this.rupiahModeUangSaku('ditanggungPerusahaan',l)
                }
            }
            this.moving()
        },
        viewData(value) {
            let generate = this.datas[value]
            this.viewNama = generate.nama
            this.viewNik = generate.nik
            this.viewTotalGaji = generate.totalGaji

            this.viewTotalPenghasilanTetap = generate.totalPenghasilanTetap
            this.viewTotalPenghasilanTidakTetap = generate.totalPenghasilanTidakTetap
            this.viewTotalDitanggungPegawai = generate.totalDitanggungPegawai
            this.viewTotalDitanggungPerusahaan = generate.totalDitanggungPerusahaan

            this.viewDetailPenghasilanTetap = generate.daftarPenghasilanTetap
            this.viewDetailPenghasilanTidakTetap = generate.daftarPenghasilanTidakTetap
            this.viewDetailDitanggungPegawai = generate.daftarDitanggungPegawai
            this.viewDetailDitanggungPerusahaan = generate.daftarDitanggungPerusahaan

            this.viewUnix = generate.unix
            this.viewBulan = generate.bulan
            this.viewTahun = generate.tahun
            this.viewIdPeg = generate.idPegawai
            this.viewHkp = generate.hkp
            this.detailModal = true

            let bulan = this.viewBulan
            let month = ''
            if(bulan == '1' || bulan == '01') {
                month = 'Januari'
            } else if(bulan == '2' || bulan == '02') {
                month = 'Februari'
            } else if(bulan == '3' || bulan == '03') {
                month = 'Maret'
            } else if(bulan == '4' || bulan == '04') {
                month = 'April'
            } else if(bulan == '5' || bulan == '05') {
                month = 'Mei'
            } else if(bulan == '6' || bulan == '06') {
                month = 'Juni'
            } else if(bulan == '7' || bulan == '07') {
                month = 'Juli'
            } else if(bulan == '8' || bulan == '08') {
                month = 'Agustus'
            } else if(bulan == '9' || bulan == '09') {
                month = 'September'
            } else if(bulan == '10') {
                month = 'Oktober'
            } else if(bulan == '11') {
                month = 'November'
            } else if(bulan == '12') {
                month = 'Desember'
            }

            this.viewBulanConvert = month
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
        separatorInterval(val) {
            if(val == 'H') {
                return 'Hari'
            } else if(val == 'M') {
                return 'Minggu'
            } else {
                return 'Bulan'
            }
        },
        separatorRupiah(val) {
            let values = val.toString()
            let vals = ''
            let clear = ''
            if(values[0] == 'R') {
                clear = values.replace("Rp. ", '')
                var o
                for(o=0;o<clear.length;o++) {
                    if(clear[o] == '.') {
                        //
                    } else {
                        vals += clear[o]
                    }
                }
            } else {
                vals = values
            }
            let leng = vals.length
            let sisa 	= leng % 3
            let rupiah 	= vals.substr(0, sisa)
            let ribuan 	= vals.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return rupiah 
        },
        separatorSatuan(val) {
            if(val == 'N') {
                return 'Desimal'
            } else {
                return 'Persentase'
            }
        },
        rupiahModeUangSaku(param, id) {
            let number_string = ''
            if(param == 'penghasilanTetap') {
                number_string = this.editDetailPenghasilanTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            } 
            if(param == 'penghasilanTidakTetap') {
                number_string = this.editDetailPenghasilanTidakTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            if(param == 'ditanggungPegawai') {
                number_string = this.editDetailDitanggungPegawai[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            if(param == 'ditanggungPerusahaan') {
                number_string = this.editDetailDitanggungPerusahaan[id].nominal.toString().replace(/[^,\d]/g, '')
            }

            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'penghasilanTetap') {
                this.editDetailPenghasilanTetap[id].nominal = hasil
            } 
            if(param == 'penghasilanTidakTetap') {
                this.editDetailPenghasilanTidakTetap[id].nominal = hasil
            }
            if(param == 'ditanggungPegawai') {
                this.editDetailDitanggungPegawai[id].nominal = hasil
            }
            if(param == 'ditanggungPerusahaan') {
                this.editDetailDitanggungPerusahaan[id].nominal = hasil
            }
        },

        loadFile() {
            this.loadingUpload = true
            let nama = document.getElementById('inputFile').files[0]

            this.dataImport = []
            this.filesImport = document.getElementById('inputFile').files[0];

            const formData = new FormData();
            formData.append("file", this.filesImport)
            DataApi.post("import/salary/transaksi/preview", formData)
            .then(res => {
                let temp = res.data
                if(temp.success == true) {
                    this.dataImport = temp.data
                    this.jumlahInvalid = temp.data.jumlahInvalid
                    this.jumlahValid = temp.data.jumlahValid
                    this.infoImport = nama.name
                } else {
                    this.tableReview = []
                    this.dataImport = []
                    this.jumlahInvalid = ''
                    this.jumlahValid = ''
                    this.alertMessImport = temp.message
                    this.currentAlertCounterImport = 7
                    this.successImport = false
                    window.scroll({
                        top:0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
                this.loadingUpload = false
            })
        },
        sumbitImport() {
            this.loadingImport = true
            let payload = this.dataImport.data
            DataApi.post("import/salary/transaksi", payload )
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.loadingImport = false
                this.dataImport = []
                this.infoImport = ''
                this.goArea = '1'
                this.jumlahInvalid = ''
                this.jumlahValid = ''
                this.currentAlertCounter = 7
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.setDate()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
</style>